module.exports = __webpack_public_path__ + "static/media/cara_happy_eyes_open.20f946e1.png";